import { getTours } from '@helpers/helper.properties'
import { ElementHTML, getVideos } from '@helpers/helper.rendering'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  setCurrentlyBlueprint,
  setCurrentlyImage,
  setTogglerBlueprints,
  setTogglerImages,
} from '@slices/galerySlice'
import React, { useEffect } from 'react'
import { useRef, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Slider from 'react-slick'
import { Video, Photo, RealEstateDataPageComponentData } from 'types'
// import { setCurrentlyBlueprint, setTogglerBlueprints } from '../redux/propertiesDucks';

const settingsSlick = {
  dots: false,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

interface ExternalProps {
  developmentID?: string
  propertyID?: string
}

type CombinedProps = ExternalProps & RealEstateDataPageComponentData

const SliderComponent_1 = ({
  propertyID,
  developmentID,
  title,
  type = 'images',
  global_data,
  is_wide,
  upperCaseLink,
  alignCenter,
  titleSecondary,
  titleElement,
}: CombinedProps) => {
  const [positionSlider, setPositionSlider] = useState(1)

  const { data, isLoading } = developmentID
    ? useQueryDevelopment(developmentID, global_data.pageConfig.keys.tokko)
    : useQueryProperty(propertyID!, global_data.pageConfig.keys.tokko)

  const sliderRef = useRef<any>()

  const [size, setSize] = useState(0)

  useEffect(() => {
    if (data) {
      switch (type) {
        case 'images': {
          setSize(data?.photos?.filter((element: Photo) => !element.is_blueprint).length)
          break
        }
        case 'blueprints': {
          setSize(data?.photos?.filter((element: Photo) => element.is_blueprint).length)
          break
        }
        case 'videos': {
          setSize(getVideos(data?.videos).length)
          break
        }
        case 'tours': {
          setSize(getTours(data).length)
          break
        }
      }
    }
  }, [isLoading])

  const dispatch = useDispatch()

  const getElementsByType = () => {
    switch (type) {
      case 'images': {
        return data?.photos?.filter((element: Photo) => !element.is_blueprint)
      }
      case 'blueprints': {
        return data?.photos?.filter((element: Photo) => element.is_blueprint)
      }
      case 'videos': {
        return getVideos(data?.videos)
      }
      case 'tours': {
        return getTours(data)
      }
      default:
        return []
    }
  }
  const getSectionByType = () => {
    switch (type) {
      case 'images': {
        return 'Imagenes'
      }
      case 'blueprints': {
        return 'Planos'
      }
      case 'videos': {
        return 'Videos'
      }
      case 'tours': {
        return 'Tours'
      }
      default:
        'return []'
    }
  }

  const afterChangeFunction = (e: any) => {
    setPositionSlider(e + 1)
    switch (type) {
      case 'images': {
        return dispatch(setCurrentlyImage(e + 1))
      }
      case 'blueprints': {
        return dispatch(setCurrentlyBlueprint(e + 1))
      }
    }
  }

  return (
    (size > 0 || isLoading) && (
      <section id={getSectionByType()}>
        <div
          id="slider-section"
          className={
            'a p-y-config slider-' +
            type +
            ' ' +
            size +
            ' ' +
            (size === 0 ? ' d-none' : '') +
            (is_wide ? 'wide-gallery' : '')
          }
        >
          <Container fluid>
            <span className={'conPag ' + type}>
              {positionSlider} / {size}
            </span>
            {/* <Slider afterChange={(e) => setPositionSlider(e+1) + (type === 'images' && dispatch(setCurrentlyBlueprint(e+1)))} ref={sliderRef} {...settingsSlick}> */}
            <Slider
              afterChange={(e) => afterChangeFunction(e)}
              ref={sliderRef}
              {...settingsSlick}
            >
              {type === 'images' || type === 'blueprints'
                ? getElementsByType()?.map((photo: Photo, i: number) => (
                    <div
                      key={i}
                      className={'col-12' + (alignCenter ? ' text-center' : '')}
                    >
                      <div className="vista">
                        <div
                          className={'py-4 position-relative' + (alignCenter ? ' text-center' : '')}
                        >
                          <ElementHTML
                            elementType={titleElement || 'h2'}
                            className={
                              (upperCaseLink ? 'text-uppercase' : '') +
                              ' section-title mb-0 mb-lg-4 mx-auto ' +
                              (titleSecondary ? ' secondary-color' : 'primary-color')
                            }
                            children={
                              title ||
                              photo.description ||
                              (type === 'images'
                                ? 'Imagenes'
                                : type === 'blueprints'
                                ? 'Planos'
                                : 'Videos')
                            }
                          />
                        </div>
                        {/* <div  onClick={() => (type === 'images' && dispatch(setTogglerBlueprints()))} className="div-iframe cursor-pointer position-relative"> */}
                        <div
                          onClick={() =>
                            dispatch(
                              type === 'images' ? setTogglerImages() : setTogglerBlueprints(),
                            )
                          }
                          className="div-iframe cursor-pointer position-relative"
                        >
                          <img
                            src={photo.original}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  ))
                : getElementsByType()?.map((video: Video, i: number) => (
                    <div
                      className="col-12"
                      key={i}
                    >
                      <div className="vista">
                        <div
                          className={'py-4 position-relative' + (alignCenter ? ' text-center' : '')}
                        >
                          <ElementHTML
                            elementType={titleElement || 'h2'}
                            className={
                              (upperCaseLink ? 'text-uppercase' : '') +
                              ' section-title mb-0 mb-lg-4 mx-auto ' +
                              (alignCenter ? ' text-center' : '') +
                              (titleSecondary ? ' secondary-color' : 'primary-color')
                            }
                            children={video.title}
                          />
                        </div>
                        {type === 'videos' && (
                          <iframe
                            allowFullScreen={true}
                            src={
                              video.player_url
                                ? video.player_url +
                                  (video.provider === 'youtube'
                                    ? '?fs=1&autoplay=0&rel=0&showinfo=0&modestbranding=1'
                                    : '')
                                : ''
                            }
                            frameBorder={0}
                          ></iframe>
                        )}
                        {type === 'tours' && <iframe src={video ? video.player_url : ''}></iframe>}
                        <div className="div-iframe cursor-pointer position-relative"></div>
                      </div>
                    </div>
                  ))}
            </Slider>
            <div
              className={
                'arrows-left zindex-1' + (size === 1 || positionSlider === 1 ? ' d-none' : '')
              }
            >
              <div
                className="arrow"
                onClick={() => sliderRef?.current?.slickPrev()}
              >
                {' '}
                <i></i> <i></i>
              </div>
            </div>
            <div
              className={
                'arrows-right zindex-1' + (size === 1 || positionSlider === size ? ' d-none' : '')
              }
            >
              <div
                className="arrow"
                onClick={() => sliderRef?.current?.slickNext()}
              >
                {' '}
                <i></i> <i></i>{' '}
              </div>
            </div>
            {type === 'images' || type === 'blueprints' ? (
              <span
                onClick={() =>
                  dispatch(type === 'images' ? setTogglerImages() : setTogglerBlueprints())
                }
                className="legend-fullscreen"
              >
                Abrir galería de {type === 'blueprints' ? 'planos' : 'imagenes'}
              </span>
            ) : (
              ''
            )}
          </Container>
        </div>
      </section>
    )
  )
}

export default SliderComponent_1
